import { createServerFn } from "@tanstack/react-start";

import { getRequestLogger, setRouteAction } from "#/lib/requestLogger.server";
import { loadPremiumPageInputSchema } from "#/lib/serverInputSchemas";
import { isEarlyBirdPromoAvailable } from "#/server/billing/earlyBirdPromoAvailability.server";
import { reconcilePlayerSubscriptionIfStale } from "#/server/billing/reconcilePlayerSubscription.server";
import { resolveRequestGameContext } from "#/server/game/requestGameContext.server";

export const loadPremiumPage = createServerFn({ method: "GET" })
  .validator(loadPremiumPageInputSchema)
  .handler(async ({ data }) => {
    setRouteAction("premium");
    const log = getRequestLogger();
    const { isAnonymous, playerId, player, entitlements } = await resolveRequestGameContext();
    const earlyBirdAvailable = await isEarlyBirdPromoAvailable({ log });
    const showEarlyBirdPromo = entitlements.tier !== "premium" && earlyBirdAvailable;

    if (isAnonymous || !player) {
      return { hasBillingRecord: false, showEarlyBirdPromo };
    }
    const refreshed = data.checkoutSuccess
      ? await reconcilePlayerSubscriptionIfStale({ clerkUserId: playerId, player, force: true })
      : player;
    return {
      hasBillingRecord: Boolean(refreshed.subscription),
      showEarlyBirdPromo,
    };
  });
